
import { getWindow } from './dom-utils';

/**
 * Provides an expected format for working with paths.
 * 
 * @param {String} path  Optional. If not provided, defaults to location.pathname
 * 
 * @return {String} With one slash on the front and no slashes on the back.
 */
export function normalizePath(path) {
  let pathname = path || getWindow().location.pathname;
  pathname = pathname.replace(/^\/*/, '/'); // Make sure there's one slash on the front.
  pathname = pathname.replace(/\/*$/, ''); // Make sure there's no slashes on the back.
  pathname = pathname || '/'; // An empty path becomes "/".
  return pathname;
}

/**
 * Execute a callback when the page lives at the provided path.
 * 
 * @param {Array|String} paths     The path(s) to detect. 
 * @param {Function}     callback  The callback to execute.
 * 
 * @return {undefined}
 */
export function onPath(paths, callback) {
  let   matched = false;
  const curPath = normalizePath();

  // Make sure we have an array
  if (typeof paths === 'string') {
    paths = [paths];
  }

  // Find the first instance of a matching path in our array
  paths.some(path => {

    if (curPath === normalizePath(path)) {
      matched = true;
    
    // If the target path is like 'olark.com/foo/*', allow
    // matches for things like 'olark.com/foo/bar'
    } else if (path[path.length - 1] === '*') {
      path = path.replace(/\*$/, '');
      if (curPath.slice(0, path.length) === path) {
        matched = true;
      }
    }

    return matched;
  });

  // If we found a match, exec the callback
  if (matched) {
    callback();
  }

}